// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionAnswers = function (x) {
    return x;
};
var tsBridgeSectionAnswers = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionAnswers")("__brandSectionAnswers"));
    }
};
var writeSectionAnswers = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionAnswers = Data_Show.showString;
var readSectionAnswers = Simple_JSON.readString;
var ordSectionAnswers = Data_Ord.ordString;
var newtypeSectionAnswers = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionAnswers = SectionAnswers;
var eqSectionAnswers = Data_Eq.eqString;
export {
    SectionAnswers,
    makeSectionAnswers,
    unwrap,
    newtypeSectionAnswers,
    eqSectionAnswers,
    ordSectionAnswers,
    showSectionAnswers,
    readSectionAnswers,
    writeSectionAnswers,
    tsBridgeSectionAnswers
};
//# sourceMappingURL=index.js.map
